module.exports = __webpack_public_path__ + "img/noticia-27.3b4f0dbe.jpg";